import { Record, List } from 'immutable';
import ShippingMethod from './ShippingMethod';
import InvoiceItem from './InvoiceItem';
import OrderItem from './OrderItem';
import Store from './Store';

const ShoppingCartDefaults = {
  id: null,
  alerts: new List(),
  shipping_method_id: null,
  shipping_address_id: null,
  payment_method_id: null,
  has_alcohol: true,
  checkout_message: null,
  marketing_message: null,
  items: new List(),
  shipping_methods: new List(),
  invoice: new List(),
  store: null,
  coupon_code: '',
  has_expired_coupon: null,
  promotion: null,
};

class ShoppingCart extends Record(ShoppingCartDefaults) {
  constructor(values) {
    values.shipping_methods = (new List(values.shipping_methods)).map((sm) => {return (sm instanceof ShippingMethod ? sm : new ShippingMethod(sm));});
    values.items = (new List(values.items)).map((oi) => {return (oi instanceof OrderItem ? oi : new OrderItem(oi));});
    values.invoice = (new List(values.invoice)).map((ii) => {return (ii instanceof InvoiceItem ? ii : new InvoiceItem(ii));});
    values.store = (values.store instanceof Store) ? values.store : new Store(values.store);
    values.alerts = (values.alerts instanceof List) ? values.alerts : new List(values.alerts);

    super(values);
  }

  get shipping_method() {
    return this.shipping_methods.find((sm) => {return sm.id === this.shipping_method_id;});
  }

  get subtotal_text() {
    return this.invoice.find((ii) => {return ii.type === 'subtotal';}).value;
  }

  get total_text() {
    return this.invoice.find((ii) => {return ii.type === 'total';}).value;
  }

  get total_item_count() {
    return this.items.reduce((sum, item) => {
      return sum + item.quantity;
    }, 0);
  }

  findAlertByItemId(itemId) {
    return this.alerts.find((alert) => {return alert.order_item_id === itemId;});
  }

  findItemByInventoryRecordId(inventoryRecordId) {
    return this.items.find((item) => {return item.inventory_record.id === inventoryRecordId;});
  }
}

export default ShoppingCart;



// WEBPACK FOOTER //
// banquet/models/ShoppingCart.js